import { CategoryTreeObject } from "@vviinn/user-managment-client-ts";
import { traverseCategoryTree } from "./traverseCategoryTree";

export const findByCode = (
  code: string,
  tree: CategoryTreeObject,
): [CategoryTreeObject, CategoryTreeObject[]] | undefined =>
  traverseCategoryTree((c) => c.categoryCode === code, tree);
